export default __webpack_public_path__ + "static/media/cargo-home-banner-1.6f309d1f.jpeg";